import axios from 'axios';
import {message} from 'antd'

import {getCookie, config} from './helpers.js';

const ROOT_URL = getCookie('api_url') ? getCookie('api_url') : config('api.url');
const token = getCookie('fl_admin_access_token');

const api = axios.create({
    baseURL: ROOT_URL
});

// Set Headers for Request
api.interceptors.request.use(config => {
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers['X-Auth-Token'] = `4sC6KWJisLkOkFQCW5xU`;
    }

    // Remove Authorization for login
    if (isAuthRequest(config)) {
        delete config.headers.Authorization;
    }

    config.meta = config.meta || {}
    config.meta.requestStartedAt = new Date().getTime();

    // Ensure Laravel receives correct headers and method shaping for Laravel
    try {
        const method = (config.method || '').toLowerCase();
        const isPut = method === 'put';
        const isPatch = method === 'patch';
        const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
        // For JSON payloads on PUT/PATCH, add proper Content-Type
        if ((isPut || isPatch) && !isFormData) {
            // Don't override if explicitly set elsewhere
            if (!config.headers['Content-Type'] && !config.headers['content-type']) {
                config.headers['Content-Type'] = 'application/json';
            }
        }
        // For multipart FormData on PUT/PATCH, tunnel via POST with _method override for Laravel
        if ((isPut || isPatch) && isFormData) {
            const override = isPut ? 'PUT' : 'PATCH';
            if (!config.data.has || !config.data.has('_method')) {
                try { config.data.append('_method', override); } catch (_) {}
            }
            config.method = 'post';
            // Do NOT set Content-Type manually for FormData; browser will set correct boundary
        }
    } catch (_) {
        // noop: be defensive
    }

    return config;
}, error => Promise.reject(error));

function statsResponseHandler(response) {
    return response;
}

function errorResponseHandler(error) {
    message.error(error.response.data.message);

    return Promise.reject(error);
}

// Global error handling for all responses
api.interceptors.response.use(
    statsResponseHandler,
    errorResponseHandler
);

function isAuthRequest(config) {
    return !!(config.url.includes('/auth/token') || config.url.includes('/auth/facebook'));
}

/*
 * Exports
 */
export default class Api {
    static auth(userToken = null) {
        return axios({
            method: "get",
            url: "/v1/user",
            baseURL: "https://api.fitlap.ee",
            headers: {
                'Authorization': `Bearer ${userToken ? userToken : token}`
            },
        });
    }

    static authEmail(username, password) {
        return axios.post('https://api.fitlap.ee/admin/auth/token', {'username': username, 'password': password});
    }

    static authVerify(googleAuthId, authNumber) {
        return axios.post('https://api.fitlap.ee/auth/2fa/verify', {'user_id': googleAuthId, '2fa_code': authNumber});
    }

    static get(url, params = {}) {
        return api.get(url, { params: params });
    }

    static post(url, data = null) {
        return api.post(url, data);
    }

    static put(url, data = null) {
        return api.put(url, data);
    }

    static delete(url, data = null) {
        return api.delete(url, {data: data});
    }
}
